import { render, staticRenderFns } from "./student-exam-list-for-meoy.vue?vue&type=template&id=5a63cce3&"
import script from "./student-exam-list-for-meoy.vue?vue&type=script&lang=js&"
export * from "./student-exam-list-for-meoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports